// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__ZzLeQ","alignLeft":"Title_alignLeft__IKzNS","alignCenter":"Title_alignCenter__Y9Nel","alignRight":"Title_alignRight__y7GKM"};